module.exports = __webpack_public_path__ + "img/nm_home_teaser2_illustration.19061415.png";